import { all, put, call } from 'redux-saga/effects'
import getMenuData from 'services/menu'
import Common from 'services/common'

export function* GET_DATA() {
  // var currentSelection = yield reduxStore.subscribe(() => {
  //   console.log(reduxStore.getState().accdetails)
  // })

  var menuData = yield call(getMenuData)
  var userAccess = Common.decryptData(localStorage.getItem('UserAcc'), true)
  // var SelectedCluster = Common.getSelectedCluster(reduxStore.getState().accdetails)
  //   ? Common.getSelectedCluster(reduxStore.getState().accdetails)
  //   : ''
  // var SelectedScope = Common.getScope(reduxStore.getState().accdetails)
  //   ? Common.getScope(reduxStore.getState().accdetails)
  //   : ''
  if (userAccess === 'User - No Access') {
    menuData = []
  }
  if (
    userAccess !== null &&
    userAccess !== 'Admin - SecAdmin Security Engineer' &&
    userAccess !== 'User - SecAdmin Security Engineer' &&
    userAccess !== 'Admin - Security Engineer') {
    var temp = menuData
    for (var i = 0; i < temp.length; i++) {
      if (temp[i]['title'] === "System" && temp[i]['key'] === "system") {
        var sysMenu = temp[i]['children']
        for (var j = 0; j < sysMenu.length; j++) {
          if (sysMenu[j]['title'] === 'Utilization' && sysMenu[j]['key'] === 'utilization') {
            sysMenu.splice(j, 1)
            menuData = temp
          }
          if (sysMenu[j]['title'] === "Administration" && sysMenu[j]['key'] === "secadmin") {
            sysMenu.splice(j, 1)
            menuData = temp
          }
        }
      }
    }
  }
  // if (SelectedCluster) {
  //   var scopes = []
  //   for (var i = 0; i < SelectedCluster['scope_access'].length; i++) {
  //     scopes.push(SelectedCluster['scope_access'][i].scope_id)
  //     if (
  //       SelectedCluster['scope_access'][i] === 'No Access' &&
  //       urlscope === SelectedCluster['scope_access'][i].scope_id
  //     ) {
  //       menuData = []
  //       // console.log(menuData)
  //     }
  //   }
  //   if (scopes.indexOf(SelectedScope.scope_id) === -1) {
  //     // console.log(scopes, scopes[SelectedScope.scope_id], SelectedScope.scope_id)
  //     menuData = []
  //   }
  // }
  window.onhashchange = function () {
    // window.location.reload(false)
  }
  // console.log(menuData, SelectedScope)
  yield put({
    type: 'menu/SET_STATE',
    payload: {
      menuData,
    },
  })
}

// const mapStateToProps = ({ user }) => ({
//   currentCluster: user.selectedCluster,
//   currentScope: user.selectScope,
// })
// @connect(mapStateToProps)

export default function* rootSaga() {
  yield all([
    GET_DATA(), // run once on app load to fetch menu data
  ])
}
